import { ShippingPreference } from '@app/types/monolith/cart';

export enum ShippingMethod {
  Express = 'EXPRESS',
  Standard = 'STANDARD',
}

export const DEFAULT_SHIPPING_METHOD = ShippingMethod.Standard;

// XXX(jj) 20241210: We currently represent "standard" and "express" shipping in 2 ways, in 2 places:
// "UPPERCASE" from the cart-bff GQL schema, and
// "lowercase" from the /cart.json endpoint from the monolith.
// These utilities here aim to keep the 2 schemas in sync with each other
// and provide easy conversions between the 2;
const toMonolith: Record<ShippingMethod, ShippingPreference> = {
  [ShippingMethod.Express]: 'express',
  [ShippingMethod.Standard]: 'standard',
} as const;

const toGql: Record<ShippingPreference, ShippingMethod> = {
  express: ShippingMethod.Express,
  standard: ShippingMethod.Standard,
} as const;

export const toMonolithShippingPreference = (
  shippingMethod: ShippingMethod
): ShippingPreference => {
  return toMonolith[shippingMethod];
};

export const toGqlShippingMethod = (
  shippingPreference: ShippingPreference
): ShippingMethod => {
  return toGql[shippingPreference];
};
